
import { defineComponent } from 'vue';
import OrderTypesMixin from '@/modules/orderTypes/mixins/OrderTypesMixin';
import EmployeeMixin from '@/modules/employee/mixins/EmployeeMixin';

export default defineComponent({
  name: 'WCActiveOrderTypeBadge',
  mixins: [OrderTypesMixin, EmployeeMixin],
});
